import { regExps } from '$constants'
import {
  formatNumber,
  formatPercent,
  getThousandsSeparator,
} from 'src/components/common/helpers'

/**
 * Validates and transforms a textfield number value
 * @param newValue the value to be validated
 * @param onlyPostiveNumbers the onlyPositiveNumbers flag
 * @returns Validated and transformed value
 */
export const transformTextFieldNumberOnChange = (
  newValue: string,
  onlyPostiveNumbers: boolean | undefined
): string => {
  //This prevents the user to insert more than one dot in the input
  if (regExps.multipleDotsPattern.test(newValue) && newValue.endsWith('.')) {
    newValue = newValue.slice(0, -1)
  }

  // This prevents negative numbers if the onlyPostiveNumbers flag is set
  if (onlyPostiveNumbers && newValue.startsWith('-')) {
    newValue = newValue.slice(1)
  }

  return newValue
}

export const formatTextFieldValueByVariant = (
  value: string,
  numberPrecision: 0 | 1 | 2 | 3,
  variant?: 'currency' | 'percent' | 'number' | 'hour' | 'input'
): string => {
  switch (variant) {
    case 'currency':
      return onBlurCurrencyHandler(value)
    case 'percent':
      return onBlurPercentHandler(value)
    case 'number':
      return onBlurNumberHandler(value, numberPrecision)
    case 'hour':
      return onBlurPercentHandler(value)
    default:
      return value
  }
}

export const getOnFocusValue = () => {}

const onBlurCurrencyHandler = (value: string) => {
  // a currency type field will have an adornment showing the currency
  // symbol, we don't actually want to format the input value as currency
  return value ? formatNumber(value, 2) : ''
}

const onBlurPercentHandler = (value: string) => {
  return value ? formatPercent(+value, true) : ''
}

const onBlurNumberHandler = (value: string, numberPrecision: number) => {
  return value ? formatNumber(+value, numberPrecision) : ''
}

export const removeThousandsSeparators = (value: string): string => {
  const re = new RegExp(getThousandsSeparator(), 'g')
  const rawValueWithoutSeparators = String(value).replace(re, '')

  return rawValueWithoutSeparators
}
